import FormControl from "@mui/material/FormControl";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import styled from "styled-components";

import PrimaryButton from "../../../components/ui/PrimaryButton";

import { SearchIcon } from "../../../assets/icons/svgs/Icons";

// Styled components
const CancelButton = styled(PrimaryButton)`
  background: white;
  border: 1px solid #d9d9d9;
  color: black;
  padding: 6px;
  width: auto;

  &:hover {
    background: lab(from white calc(l - 5) a b / 1);
  }
`;

const ContentControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0;
  width: 100%;
`;

const ContentModeButton = styled(PrimaryButton)`
  background: ${({ $isSelected }) =>
    $isSelected ? "var(--terbine-blue)" : "#D9D9D9"};
  color: ${({ $isSelected }) => ($isSelected ? "white" : "black")};
  height: 40px;
  padding: 0 20px;
  width: auto;

  &:hover {
    background: lab(
      from
        ${({ $isSelected }) =>
          $isSelected ? "var(--terbine-blue)" : "#D9D9D9"}
        calc(l - 5) a b / 1
    );
  }
`;

const ContentModeButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

const Icon = styled.img`
  height: auto;
  // margin-left: clamp(5px, 1vw, 10px);
  width: 16px;
`;

const InboundButton = styled(ContentModeButton)`
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
`;

const SearchAndNewGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const Modal = styled.div`
  align-items: center;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  flex-direction: column;
  gap: 8px;
  left: 50%;
  max-height: 80%;
  max-width: 80%;
  min-width: 70%;
  overflow-y: auto;
  padding: 20px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  z-index: 110;
`;

const OutboundButton = styled(ContentModeButton)`
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`;

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 109;
`;

const SelectFeedButton = styled(PrimaryButton)`
  padding: 4px 8px;
  min-width: 120px;
  width: 100%;

  &:hover {
    background: lab(from var(--terbine-blue) calc(l - 5) a b / 1);
  }
`;

const UseExistingConfigButton = styled(PrimaryButton)`
  background: var(--terbine-dark-gray);
  padding: 6px;
  width: auto;

  &:hover {
    background: lab(from var(--terbine-dark-gray) calc(l - 5) a b / 1);
  }
`;

const testData = [
  {
    name: "name_1",
    description: "description_1",
    type: "Continuous",
    created: "04/01/2025",
    modified: "04/14/2024",
    sourceType: "Charging Station",
    sensorType: "RFID",
  },
  {
    name: "name_2",
    description: "description_2",
    type: "Continuous",
    created: "04/01/2025",
    modified: "04/14/2024",
    sourceType: "Charging Station",
    sensorType: "RFID",
  },
  {
    name: "name_3",
    description: "description_3",
    type: "Continuous",
    created: "04/01/2025",
    modified: "04/14/2024",
    sourceType: "Charging Station",
    sensorType: "RFID",
  },
];

const SelectFeedModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [contentMode, setContentMode] = useState("Inbound");

  const [search, setSearch] = useState("");

  // simply toggle state of the modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div>
      <SelectFeedButton onClick={toggleModal}>Select Feed</SelectFeedButton>

      <Overlay $isOpen={isModalOpen} onClick={toggleModal} />

      <Modal $isOpen={isModalOpen} id="modal">
        <Typography variant="h4" sx={{ color: "black", mb: 1 }} gutterBottom>
          Select Feed
        </Typography>

        <ContentControls>
          <ContentModeButtons>
            <InboundButton
              $isSelected={contentMode === "Inbound"}
              onClick={() => setContentMode("Inbound")}
            >
              Inbound Feeds
            </InboundButton>
            <OutboundButton
              $isSelected={contentMode === "Outbound"}
              onClick={() => setContentMode("Outbound")}
            >
              Outbound Feeds
            </OutboundButton>
          </ContentModeButtons>

          <SearchAndNewGroup>
            <FormControl>
              <TextField
                onChange={(e) => {
                  // setTablePage(0);
                  setSearch(e.target.value);
                }}
                placeholder="Search"
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <SearchIcon />
                    ),
                    // endAdornment: search ? (
                    //   <Icon
                    //     onClick={() => setSearch("")}
                    //     src={CancelIcon}
                    //     style={{
                    //       cursor: "pointer",
                    //       marginLeft: "10px",
                    //       marginRight: "0",
                    //     }}
                    //   />
                    // ) : (
                    //   <Icon style={{ marginLeft: "10px", marginRight: "0" }} />
                    // ),
                  },
                }}
                value={search}
              />
            </FormControl>
          </SearchAndNewGroup>
        </ContentControls>

        <TableContainer
          component={Paper}
          sx={{
            borderRadius: "8px",
            boxShadow: "none",
            "& *": {
              fontFamily: "Inter, Oxygen, Roboto, sans-serif",
            },
          }}
        >
          <Table
            sx={{
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "var(--terbine-blue)",
                  "& th": {
                    color: "white",
                    fontSize: "clamp(12px, 1.5vw, 18px)",
                    fontWeight: 300,
                    borderBottom: "none",
                  },
                  borderBottom: "none",
                }}
              >
                {[
                  { label: "Name" },
                  { label: "Description" },
                  { label: "Type" },
                  { align: "center", label: "Created" },
                  { align: "center", label: "Last Modified" },
                  { label: "Source Type" },
                  { label: "Sensor Type" },
                ].map((header, i) => (
                  <TableCell
                    align={header.align || "left"}
                    key={i}
                    width={header.width || null}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {testData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: "#F2F2F2",
                    borderBottom:
                      index !== testData.length - 1
                        ? "3px solid white"
                        : "none",
                    borderTop: "none",
                    "& > td": {
                      borderTop: "none",
                      borderBottom:
                        index !== testData.length - 1
                          ? "3px solid white"
                          : "none",
                      color: "black",
                    },
                  }}
                >
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell>{row.type}</TableCell>
                  <TableCell align="center">{row.created}</TableCell>
                  <TableCell align="center">{row.modified}</TableCell>
                  <TableCell>{row.sourceType}</TableCell>
                  <TableCell>{row.sensorType}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <UseExistingConfigButton>
            Use Existing Configuration
          </UseExistingConfigButton>
          <CancelButton onClick={() => setIsModalOpen(false)}>Cancel</CancelButton>
        </div>
      </Modal>
    </div>
  );
};

export default SelectFeedModal;
